<template>

    <content menu="申请书" :location = "['申请书']"> 
       <!-- <pdfPlayer class="pdfPlayer" pdfUrl = './files/application_form.pdf'  ></pdfPlayer>	 -->
	   <pdfPlayer class="pdfPlayer" pdfUrl = "./files/application_form.pdf" ></pdfPlayer>	
    </content>

</template>


<script>
import content from './content.vue'
import pdfPlayer from "../exhibition/pdfPlayer.vue"
	export default {
		name:"ApplicationForm",
        components:{
            content,
            pdfPlayer
        },
		props:{
		},
		data() {
			return {
                
			};
		},
		methods:{
		},
	}
</script>

<style lang="scss" scoped>

</style>